var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"network_chart section"},[_c('network',{ref:"network",staticStyle:{"width":"100% !important"},attrs:{"nodes":_vm.network,"edges":_vm.edges,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }